// extracted by mini-css-extract-plugin
export default {"container":"styles_container__sG6Qq","fixedText":"styles_fixedText__HiBVr"};